import * as React from 'react';
import { SVGProps } from 'react';

const IconLockSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9V6.5a4.5 4.5 0 0 1 9 0V9H19a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h2.5Zm2-2.5a2.5 2.5 0 0 1 5 0V9h-5V6.5Zm3.133 8.898a2 2 0 1 0-1.266 0L10 19.5h4l-1.367-4.102Z"
    />
  </svg>
);
export default IconLockSizeM;
